<template>
    <div class="setup-instructions__container">
        <template v-if="!showImageOnlyDemo">
            <div class="setup-instructions__controls">
                <div class="setup-instructions__dots-container">
                    <div class="setup-instructions__dots" v-for="(step, index) in steps">
                        <span class="animated fadeInDown circle circle-full" v-if="index === currentStep" ></span>
                        <span @click="setStep(index)" class="animated fadeInUp animated6 circle circle-empty" v-if="index !== currentStep" ></span>
                    </div>
                </div>
            </div>
            <div class="setup-instructions__step-text animated fadeInUp animated6"><h2>{{steps[currentStep]}}</h2></div>
            <div class="setup-instructions__animation">
                <div class="setup-instructions__image">
                    <img class='animated fadeInDown animated4' :src="images[currentStep]">
                </div>
            </div>
        </template>
        <img v-if="showImageOnlyDemo" class="setup-instructions__image-only-steps" src="https://cdn.patchbot.io/images/PatchBot-Setup-Tutorial-Gif-Final.gif" alt="How to Install PatchBot Video Demonstration">
    </div>
</template>
<script>
    /**
     * Usage Examples:
     *
     *  <setup-instructions></setup-instructions>
     *
     */
    export default {
        props: [],
        data: function () {
            return {
                currentStep: 0,
                steps: Array,
                images: Array,
                timer: null,
                showImageOnlyDemo: true,
            }
        },
        mounted() {
            this.steps = [
                'Login using Discord',
                'Select a Server',
                'Configure the Server',
                'Add PatchBot to the Server',
                'Toggle a channel to begin receiving game updates',
                'Profit'
            ];
            this.images = [
                '/images/step-1-login-with-discord.gif',
                '/images/step-2-select-server.gif',
                '/images/step-3-add-patchbot-1.gif',
                '/images/step-3-add-patchbot-2.gif',
                '/images/step-4-toggle-channel-subscription.gif',
                'https://media.giphy.com/media/DVjRBplv1tET6/giphy.gif'
            ];
            // Go Go Gif Slideshow!
            this.initSlideshow();
    },
        methods: {
            initSlideshow() {
               this.timer = setInterval(this.next, 8000);
            },
            next() {
                this.currentStep += 1;
                if (this.currentStep >= this.steps.length) {
                    this.currentStep = 0;
                }
            },
            previous() {
                this.currentStep -= 1;
                if (this.currentStep < 0) {
                    this.currentStep = this.steps.length - 1;
                }
            },
            stopCarousel() {
              clearInterval(this.timer);
            },
            setStep(stepIndex) {
                this.stopCarousel();
                this.currentStep = stepIndex;
            }
        },
    }
</script>

